const SUPPORT_LINKS = {
  index: {
    label: 'Support',
    href: 'https://support.sportsheadz.com/'
  }
};

export default SUPPORT_LINKS;
